export const formatCategoryName = (category) => {
    const categoryMap = {
        "Corporate NDR": "Corp NDR",
        "Conference Participation": "Conference",
        "Expert NDR": "Expert NDR",
        Events: "Events",
    };

    return categoryMap[category] || category;
};

export const TIER_CONFIGS = [
    { key: "1", name: "Tier 1", color: "#BBBEFF" },
    { key: "2", name: "Tier 2", color: "#8BDBCD" },
    { key: "3", name: "Tier 3", color: "#A0AEC0" },
    { key: "4", name: "Tier 4", color: "#40CDFA" },
    { key: "5", name: "Tier 5", color: "#ED1C24" },
    { key: "6", name: "Tier 6", color: "#AF60A8" },
    { key: "7", name: "Tier 7", color: "#8D8F94" },
    // { key: "8", name: "Tier 8", color: "#C2C89C" },
    // { key: "9", name: "Tier 9", color: "#BCB8E4" },
    // { key: "10", name: "Tier 10", color: "#FDBE94" },
];
